import { render, staticRenderFns } from "./edition_matieres.vue?vue&type=template&id=5a50bad2"
import script from "./edition_matieres.js?vue&type=script&lang=js&external"
export * from "./edition_matieres.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports